module.exports = __webpack_public_path__ + "static/img/meituan.d5811af5.jpg";